<template>
  <div class="betascore-tracker">
    <CalicoLoader v-if="loading" />

    <CalicoBetascoreTracker
      v-else
      :items="items"
      :has-you-items="hasYouItems"
      :has-organization-items="hasOrganizationItems"
      :has-history-items="hasHistoryItems"
      @toggle-sort="$emit('toggle-sort')"
      @select="$emit('select', $event)"
      @find-business="$emit('find-business')"
    />

    <CalicoPagination
      v-if="!loading && pagination.pages > 1"
      :pages="pagination.pages"
      :label="paginationLabel"
      @change-page="$emit('change-page', $event)"
    />
  </div>
</template>

<script>
import CalicoLoader from '@/components/calico/loader/index.vue';
import CalicoBetascoreTracker from '@/components/pattern/betascoreTracker/index.vue';
import CalicoPagination from '@/components/calico/pagination/index.vue';

export default {
  name: 'BetaScoreTrackerWidget',

  components: {
    CalicoLoader,
    CalicoBetascoreTracker,
    CalicoPagination
  },

  props: {
    loading: { type: Boolean, default: false },
    items: { type: Array, required: true },
    pagination: {
      type: Object,
      required: true,
      default: () => ({
        page: 1,
        limit: 20,
        pages: 1,
        total: 0
      })
    },
    hasYouItems: { type: Boolean, default: false },
    hasOrganizationItems: { type: Boolean, default: false },
    hasHistoryItems: { type: Boolean, default: false },
    sort: { type: String, default: 'recent' }
  },

  emits: [
    'toggle-sort',
    'change-page',
    'select',
    'find-business'
  ],

  computed: {
    paginationLabel() {
      const { page, limit, total } = this.pagination;
      if (!total) return '';
      return `${(page - 1) * limit + 1}-${Math.min(page * limit, total)} of ${total}`;
    }
  }
};
</script>

<style scoped lang="scss">
.betascore-tracker {
  @include stack-space($space-medium);
  padding: $space-xlarge $space-medium;
}
</style>
